import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App, ScreenLoading } from "./app.js";
import { LocaleProvider } from "./i18n/provider.js";
import { platform } from "./platform/index.js";
import { CrashBoundary } from "./shell/Crash.js";
import { ToastProvider } from "./shell/Toast.js";
import { applyTheme, preferredMode } from "./theme/apply.js";
import { DEFAULT_ACCENT } from "@planner/core";
import "./styles.css";

/** قبل أوّل رسم: لون افتراضي الآن، ولون المشتري حين يُقرأ إعداده */
applyTheme(DEFAULT_ACCENT, preferredMode());

/**
 * **وعاملُ الخدمة يُسجَّل عند الإقلاع** — فالتثبيتُ متاحٌ لمن لم يأذن بالتنبيهات.
 */
platform.registerWorker();

const root = platform.documentElement?.querySelector("#root");
if (!root) throw new Error("boot: #root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <CrashBoundary>
        <ToastProvider>
          {/** **وشاشاتُ ما قبل الدخول تُحمَّل حين تُفتَح كذلك** — والانتظارُ بهيكله */}
          <Suspense fallback={<ScreenLoading />}>
            <App />
          </Suspense>
        </ToastProvider>
      </CrashBoundary>
    </LocaleProvider>
  </StrictMode>,
);
